<template>
  <div class="login-with-app" v-if="isLoginApp">
  <div class="login-layout blur-login" :style="{ backgroundImage: `url(${require('@/assets/images/bg.png')})` }">
  <div id="mainContainer" class="main-container">
    <div class="main-content">
      <div class="">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div class="position-relative">
              <div id="login-box">
                <div >
                  <div >
                    <h4 class="header blue lighter bigger i-logo">
                      <img :src="logo" alt="logo"  width="200"/>
                    </h4>
                    <h4 class="header blue lighter bigger i-logo title-login">
                      パスワード再発行
                    </h4>
                    <div v-if="sucessStatus === true">
                      <div class="error">
                        {{ message }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="error" v-if="error === true">
                        {{ message }}
                      </div>
                    </div>
                    <p></p>
                    <form @submit.prevent="validateBeforeSubmit" novalidate>
                      <fieldset >
                        <div >
                          <div class="form-item width-80">
                            <input required autocomplete="off" name="ownerId" id="ownerId" class="form-control" v-validate="'required'" v-model="credentials.ownerId"/>
                            <label for="password" >事業者ID</label>
                            <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                          </div>
                          <div class="form-item width-80">
                            <input required autocomplete="off"  name="userId" id="userId" class="form-control" v-validate="'required'" v-model="credentials.userId"/>
                            <label for="password" v-if="isNTT">会員ID</label>
                            <label for="password" v-else>ユーザーID</label>
                            <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                          </div>
                          <div class="clearfix login-button">
                            <button  type="submit">
                              <span><img :src="`${require('@/assets/images/icon/send.png')}`" class="btn-icon"></span>
                              <span >送信する</span>
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                  <div class="forgot-password-text">
                    <router-link tag="a" :to="{ name: 'login'}" class="forgot-password-link">
                      <span><img :src="`${require('@/assets/images/icon/arrow-w.png')}`" class="btn-icon-link"></span>
                      ログインページに戻る
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  <div class="login-layout blur-login" v-else>
    <div class="main-container">
    <div class="main-content">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div v-bind:class="{'position-relative round_black': isNTT, 'position-relative' : !isNTT}">
              <div id="forgot-box" class="forgot-box visible widget-box no-border">
                <template v-if="sucessStatus === true">
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワード再発行
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-success">
                        {{ message }}
                      </div>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
                <template v-else>
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワード再発行
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-danger" v-if="error === true">
                        {{ message }}
                      </div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <fieldset>
                          <label class="block clearfix">
                            <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('ownerId') }" name="ownerId" type="text" class="form-control" v-validate="'required'"  placeholder="事業者ID" v-model="credentials.ownerId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input v-if="isNTT" :class="{ error: errors.has('userId') }" v-validate="'required'" name="userId" type="text" class="form-control" placeholder="会員ID" v-model="credentials.userId"/>
                              <input v-else :class="{ error: errors.has('userId') }" v-validate="'required'" name="userId" type="text" class="form-control" placeholder="ユーザーID" v-model="credentials.userId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <div class="clearfix">
                            <button type="submit" class="width-100 pull-right btn btn-sm btn-danger">
                              <span class="bigger-110">送信</span>
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
              </div><!-- /.forgot-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
</template>
<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      logo: 'static/img/logo-login.png',
      credentials: {
        ownerId: '',
        userId: ''
      },
      loading: false,
      sucessStatus: false,
      error: false,
      message: '',
      isNTT: false,
      isLoginApp: false
    }
  },
  created () {
    var checkNTTWeb = navigator.userAgent.match(/isNTT/)
    if (checkNTTWeb) {
      this.isNTT = true
    }
    var isMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios|alligate-mobile-userAgent-android|isNTT|isUpgrade/g)
    if (isMobileApp) {
      if (isMobileApp.indexOf('isNTT') < 0 && isMobileApp.indexOf('isUpgrade') >= 0) {
        this.isLoginApp = true
      } else {
        this.isLoginApp = false
      }
    } else {
      this.isLoginApp = false
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'login' })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          const credentials = {
            ownerId: this.credentials.ownerId,
            userId: this.credentials.userId
          }
          this.$http.post(Config.FORGOT_PASSWORD_API, JSON.stringify(credentials))
            .then(response => {
              if (response.body.message === 'Success') {
                this.sucessStatus = true
                this.loading = false
                // this.message = Config.FORGOT_API_SUCCESS_SEND_RESET_CODE
                // owserIdとuserIdの値をlocalstorageに保存する
                localStorage.setItem('ownerId', this.credentials.ownerId)
                localStorage.setItem('userId', this.credentials.userId)
                this.$router.push({name: 'resetpassword'})
              }
            })
            .catch((error) => {
              this.loading = false
              if (error.body) {
                this.error = true
                switch (error.status) {
                  case 401:
                    if (error.body.message === 'The incoming token has expired') {
                      this.message = ''
                    } else {
                      this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                    }
                    break
                  case 400:
                    this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                    break
                  case 404:
                    this.message = '該当するデーターがありません。'
                    break
                  case 500:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  case 503:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  default:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                }
              } else {
                this.error = true
                this.message = Config.SERVER_CONNECT_ERROR
              }
            })
        }
      })
    }
  }
}
</script>

<style>
body{
  background: #394557
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
.round_black .red  {
  color: #000 !important;
}
.round_black .btn-danger, .round_black .btn-danger.focus, .round_black .btn-danger:focus {
  background: #000 !important;
  border-color: #000 !important;
}
.round_black .forgot-box .toolbar {
  background: #000 !important;
  border-top: #000 !important;
}
.round_black .back-to-login-link {
  color: #fff !important;
}
.login-with-app .login-container{
  width: 100%;
  font-size: 18px;
  max-width: 800px !important;
}
.login-with-app .login-button button {
    outline: inherit;
}
.login-with-app .login-layout .login-button button {
  background: #fff !important;
  color: #1B7E47 !important;
  border: none !important;
  font-weight: 700;
  position: relative;
  height: 50px;
  width: 350px;
  font-size: 18px !important;
}
.login-with-app .login-layout .login-button button .btn-icon {
  position: absolute;
  left: 20px;
  top: 15px;
  height: 20px;

}
.login-with-app .login-layout .login-button.btn-guest {
  margin-top: 20px;
}
.login-with-app .login-layout .login-button.btn-guest button {
  background: none !important;
  color: #fff !important;
  border: solid 2px #fff !important;
}
.login-with-app .login-layout .widget-box.visible {
  margin-top: 0%;
}
.login-with-app .login-layout {
    min-height: 100vh;
    display: grid;
    align-content: center;
    background-repeat: no-repeat;
      background-size: cover;
    background-position: center;
}
.login-with-app #mainContainer {
  padding-top: 0px !important
}
.login-with-app .form-item{
  position: relative;
  margin-bottom: 15px;
  width: 100%;
  padding-top: 5px ;
  margin: 10px auto 60px auto !important;
  height: 45px !important;
}
.login-with-app .form-item input{
  display: block;
  width: 100%;
  height: 36px;
  background: transparent;
  border: none;
  border-bottom: solid 1px #fff !important;
  transition: all 3s ease;
  font-size: 18px;
  color: #fff !important;
  position: absolute;
  z-index: 3;
}
.form-item input:focus{
  background: none !important;;
}
.form-item label{
  position: absolute;
  cursor: text;
  z-index: 2;
  top: 10px;
  left: 0px;
  background: none !important;
  color: #fff;
  transition: all .3s ease;
  font-size: 18px;
}
.form-item input:focus + label,
.form-item input:valid + label{
  font-size: 18px;
  top: -15px
}
.form-item input:focus + label{
  color: #fff
}
.i-logo{
  margin-bottom: 30px;
}
.btn-icon-link {
  width: 15px;
}
.forgot-password-text{
  color: #fff;
  font-size: 18px;
  margin-top: 30px;
  text-align: center;
}
.forgot-password-text a{
  color: #fff;
}
.title-login{
  color: #fff !important;
  font-weight: bold;
  font-size: 18px;
}
div.error {
  color: red;
  text-align: center;
  margin: auto;
  margin-bottom: 10px;
}
@media only screen and (max-width: 500px) {
  .login-with-app .login-button button {
    width: 90% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/ForgotPassword.vue